import { AsyncPipe, DatePipe, NgClass } from '@angular/common';
import { Component, ElementRef, ViewChild, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslocoPipe } from '@jsverse/transloco';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SavingsPlanFacade } from '@zero/saving-plans/domain';
import { IgnoreThousandSeparatorPipe } from '../../../pipes/ignore-thousand-separator.pipe';
import { SavingsPlanDynamizationComponent } from '../../savings-plan-dynamization/savings-plan-dynamization.component';

@Component({
  selector: 'saving-plans-options',
  imports: [TranslocoPipe, AsyncPipe, DatePipe, FormsModule, IgnoreThousandSeparatorPipe, NgClass, SavingsPlanDynamizationComponent],
  templateUrl: './savings-plan-options.component.html',
})
export class SavingsPlanOptionsComponent {
  @ViewChild('dynamizationInfo', { static: true }) private readonly _content: ElementRef;

  public readonly facade = inject(SavingsPlanFacade);
  readonly #ngbModal = inject(NgbModal);

  public handleChangeSum = (ev: Event) => {
    const value = ev.target['value'];
    const sum = value ? Number(value.replace(',', '.')) : null;
    !isNaN(sum) && this.facade.changeTotalAmount(sum);
  };

  public openDynamizationInfo = () => this.#ngbModal.open(this._content, { size: 'md' });
}
